
<h2 matDialogTitle [ngClass]="titleClass">{{dialogTitle}}</h2>

<mat-dialog-content>
  <section class="dialog-content">
    <section><mat-icon class="icon" [ngClass]="iconClass">{{ icon }}</mat-icon></section>
    <div>
      <p class="dialog-text" [innerHTML]="dialogText"></p>
      <p *ngIf="fullMessageShown" class="dialog-text" [innerHTML]="fullMessage"></p>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">

  <button id="alert-show-full-message" mat-raised-button *ngIf="canShowFullMessage" (click)="onShowHideFullMessage()">
    {{ (fullMessageShown ? "Dialog_HideFullMessage" : "Dialog_ShowFullMessage") | translate }}
  </button>

  <button id="alert-cancel" mat-raised-button *ngIf="canCancel" matDialogClose="false">{{ "Cancel" | translate }}</button>
  <button id="alert-action" mat-raised-button *ngIf="canCancel" matDialogClose="true" color="warn">{{ actionButtonName }}</button>

  <button id="alert-close" mat-raised-button *ngIf="! canCancel" matDialogClose>{{ "Close" | translate}}</button>

</mat-dialog-actions>

